(function (module) {
    "use strict";

    module.component('forecastSendToApprovalForce', {
        template: require('./forecastSendToApprovalForceComponent.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: function () {
            var $ctrl: $TSFixMe = this;

            $ctrl.ok = function () {
                $ctrl.close({});
            };

            $ctrl.cancel = function () {
                $ctrl.dismiss({ $value: 'cancel' });
            };

        }
    })

})(angular.module('topline.modules'));